module.exports = __webpack_public_path__ + "static/img/avatar-s-7.9241b5d6.png";